import { LocalizedString, localizedStringFromMap } from './LocalizedString';

export interface Activity {
  id: string;
  emoji?: string;
  iconUrl?: string;
  name: LocalizedString;
  position: number;
}

export function activityFromJson(json: Record<string, unknown>): Activity {
  return {
    id: json['id'] as string,
    emoji: json['emoji'] as string | undefined,
    iconUrl: json['iconUrl'] as string | undefined,
    name: localizedStringFromMap(json['name'] as Record<string, unknown>),
    position: json['position'] as number,
  };
}
